<template>
    <div>
        <div class="">
            <div class="tableContainer">
                <div class="sampleTemplate">
                    <b-table
                        id="table1"
                        ref="table1"
                        :fields="fields"
                        :items="getBoard"
                        :per-page="perPage"
                        :current-page="currentPage"
                        @row-clicked="onRowClicked"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        hover
                        show-empty
                        empty-text="1:1 문의 이력이 존재하지 않습니다."
                        >
                            <template #emptyfiltered="scope">
                                <h4>{{ scope.emptyFilteredText }}</h4>
                            </template>
                        </b-table>
                            
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalCnt"
                        :per-page="perPage"
                        aria-controls="table">
                        </b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed:{
        ...mapGetters('auth', [
            'getUser' 
        ]),
    },
    beforeCreated(){
        this.setDataTable();
    },
    data() {
        return {
            searchText:this.$route.query.searchText,
            selected: [],
            perPage: 10,
            currentPage: 1,
            totalCnt: 0,
            sortBy: 'IDX',
            sortDesc: false,
            fields: [],
            items: [],
            routerName : ""
        }
    },
    methods:{
        onRowClicked(item){
            this.$router.push({ name: "qNADetail", params: { idx: item.IDX, searchText: this.$route.query.searchText }});
        },
        getBoard(ctx, callback){
            let searchText = this.$route.query.searchText;
            let boardObj = {
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                searchText : searchText
            };

            this.$store.dispatch('board/getBoardList', boardObj).then((data) => {
                this.setDataTable();
                callback(data.data.items);
            });

            return null;
        },
        setDataTable(){
            this.currentPage = this.$store.state.board.currentPage;
            this.perPage = this.$store.state.board.perPage;
            this.totalCnt = this.$store.state.board.totalCnt;
            this.sortBy = this.$store.state.board.sortBy;
            this.sortDesc = this.$store.state.board.sortDesc;
            this.fields = this.$store.state.board.fields;
        }
    }
}
</script>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
    }
</style>